import { getWebApp } from './telegram'

let verticalSwipesDisabledMemory = false

export function ensureVerticalSwipesDisabled() {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : null
  if (!tg || typeof tg.disableVerticalSwipes !== 'function') {
    return false
  }

  if (typeof tg.isVerticalSwipesEnabled === 'boolean') {
    if (tg.isVerticalSwipesEnabled === false) {
      verticalSwipesDisabledMemory = true
      return false
    }
  } else if (verticalSwipesDisabledMemory) {
    return false
  }

  try {
    tg.disableVerticalSwipes()
    verticalSwipesDisabledMemory = true
    return true
  } catch (error) {
    console.error('[WebApp] disableVerticalSwipes failed', error)
    return false
  }
}

export function safeShowAlert(message) {
  const text = String(message ?? 'Произошла ошибка')
  try {
    const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : null
    if (tg && typeof tg.showAlert === 'function') {
      tg.showAlert(text)
      return
    }
  } catch (error) {
    console.error('[WebApp] safeShowAlert Telegram failed', error)
  }

  try {
    window.alert(text)
  } catch (error) {
    console.error('[WebApp] safeShowAlert window.alert failed', error)
  }
}

export function safeOpenLink(url) {
  const link = String(url ?? '').trim()
  if (!link) {
    throw new Error('Пустая ссылка на оплату')
  }

  const tg = getWebApp()
  try {
    if (typeof tg.openLink === 'function') {
      tg.openLink(link)
      return
    }
  } catch (error) {
    console.error('[WebApp] safeOpenLink Telegram failed', error)
  }

  window.open(link, '_blank', 'noopener,noreferrer')
}

export function safeOpenTelegramLink(url) {
  const link = String(url ?? '').trim()
  if (!link) return

  const tg = getWebApp()
  try {
    if (typeof tg.openTelegramLink === 'function') {
      tg.openTelegramLink(link)
      return
    }
  } catch (error) {
    console.error('[WebApp] safeOpenTelegramLink failed', error)
  }
  try {
    if (typeof tg.openLink === 'function') {
      tg.openLink(link)
      return
    }
  } catch (error) {
    console.error('[WebApp] safeOpenTelegramLink openLink fallback failed', error)
  }
  window.open(link, '_blank', 'noopener,noreferrer')
}

export function safeSheetOpenHaptic() {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.impactOccurred?.('light')
  } catch (error) {
    console.error('[WebApp] safeSheetOpenHaptic failed', error)
  }
}

export function safeButtonHaptic() {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.impactOccurred?.('light')
  } catch (error) {
    console.error('[WebApp] safeButtonHaptic failed', error)
  }
}

export function initTelegramWebAppSafe() {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : null
  if (!tg) return null

  try {
    if (typeof tg.ready === 'function') tg.ready()
  } catch (error) {
    console.error('[WebApp] tg.ready failed', error)
  }

  try {
    if (typeof tg.expand === 'function') tg.expand()
  } catch (error) {
    console.error('[WebApp] tg.expand failed', error)
  }

  try {
    ensureVerticalSwipesDisabled()
  } catch (error) {
    console.error('[WebApp] tg.disableVerticalSwipes failed', error)
  }

  const platform = String(tg.platform || '').trim().toLowerCase()
  const isMobile = platform === 'ios' || platform === 'android'

  if (isMobile && typeof tg.requestFullscreen === 'function') {
    try {
      tg.requestFullscreen()
    } catch (error) {
      console.error('[WebApp] tg.requestFullscreen failed', error)
    }
  }

  try {
    if (typeof tg.enableClosingConfirmation === 'function') {
      tg.enableClosingConfirmation()
    }
  } catch (error) {
    console.error('[WebApp] tg.enableClosingConfirmation failed', error)
  }

  try {
    if (typeof tg.setHeaderColor === 'function') {
      tg.setHeaderColor('#08080A')
    }
  } catch (error) {
    console.error('[WebApp] tg.setHeaderColor failed', error)
  }

  try {
    if (typeof tg.setBackgroundColor === 'function') {
      tg.setBackgroundColor('#08080A')
    }
  } catch (error) {
    console.error('[WebApp] tg.setBackgroundColor failed', error)
  }

  return tg
}
